module.exports = __webpack_public_path__ + "img/index_icon3@2x.b2a4cc0d.png";